import React, { useState } from "react";
import style from "./index.module.scss";
import { Button, Checkbox, Input } from "antd";
import _ from "underscore";
import { Option } from "../../index";
import { CheckboxChangeEvent } from "antd/es/checkbox";

interface OptionsViewProps {
    selected: string[]; //选中项
    optionsData: Option[]; //下拉options
    handleSelected: (val: string[]) => void; //修改选中项
    setOpen: () => void; //修改下拉弹窗状态
}

const Index = ({
    selected,
    optionsData,
    handleSelected,
    setOpen
}: OptionsViewProps) => {
    const CheckboxGroup = Checkbox.Group;

    const [plainOptions, setPlainOptions] = useState<Option[]>(optionsData);
    const [checkedList, setCheckedList] = useState<string[]>(selected);
    const [indeterminate, setIndeterminate] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const options = _.pluck(plainOptions, "value");
    //先求并集再求差集，得到剩余的选中项
    const union = Array.from(new Set([...options, ...selected])).filter(
        item => !new Set(options).has(item)
    );

    //筛选
    const onSearch = (value: string) => {
        const newData = optionsData.filter(
            item => item.label.indexOf(value) > -1
        );
        setPlainOptions(newData);
    };

    const onChange = (checkedItem: any) => {
        //求并集，得到当前变化后的选中项和剩余选中项的合集
        const count = Array.from(new Set([...checkedItem, ...union]));
        setCheckedList(count);
        setIndeterminate(
            !!checkedItem.length && checkedItem.length < plainOptions.length
        );
        setCheckAll(checkedItem.length === plainOptions.length);
    };

    //全选
    const onCheckAllChange = (e: CheckboxChangeEvent) => {
        const selected: string[] = _.pluck(plainOptions, "value");
        setCheckedList(e.target.checked ? selected : []);
        setIndeterminate(false);
        setCheckAll(e.target.checked);
    };

    //确认
    const onConfirm = () => {
        handleSelected(checkedList);
        setOpen();
    };
    return (
        <div className={style.root}>
            <Input.Search placeholder="请输入..." onSearch={onSearch} />

            <CheckboxGroup
                options={plainOptions}
                value={checkedList}
                onChange={onChange}
            />
            <div className={style.footer}>
                <Checkbox
                    indeterminate={indeterminate}
                    onChange={onCheckAllChange}
                    checked={checkAll}>
                    全选
                </Checkbox>
                <Button type="primary" onClick={onConfirm}>
                    确认
                </Button>
            </div>
        </div>
    );
};

export default Index;
